export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  // Capa 1 anti-cookie-theft: nonce emitido por el backend al login y
  // reenviado como header X-Session-Nonce en cada request. Vive solo en
  // sessionStorage — per-window, no copiado por plugins de cookie-injection.
  SESSION_NONCE: 'wt_session_nonce',
};
